
import { useState } from "react";
import type { LoaderFunctionArgs } from "react-router-dom";
import { Button, Input, Grid, Header, Message, Segment } from 'semantic-ui-react';
import { gql } from '@apollo/client';
import { ApolloClient, InMemoryCache } from '@apollo/client';

import { PATHS } from '../../paths';

import {
  Form,
  Link,
  redirect,
  useActionData,
  useLocation,
} from "react-router-dom";

import { authProvider } from "../../auth";

import { BACKEND_URL } from '../../config';

const client = new ApolloClient({
  uri: BACKEND_URL,
  cache: new InMemoryCache(),
});

// Define mutation
const LOGIN_MUATION = gql`
  mutation Login($userName: String!, $password: String!) {
    login(userName: $userName, password: $password) {
      success
      token
      refreshToken
    }
  }
`;

function LoginPage() {
  let location = useLocation();
  let params = new URLSearchParams(location.search);
  let from = params.get("from") || PATHS.ROOT;
  const [attemptedLogin, setAttemptedLogin] = useState(false);

  let actionData = useActionData() as { error: string } | undefined;

  return (
    <>
      <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
      <Grid.Column style={{ maxWidth: 450 }}>
      {from.length > 1 && (<Message color='red'><p>You must log in to view the page at {from}</p></Message>)}
        <Header as='h2' color='teal' textAlign='center'>
          Log in to Joyya
        </Header>
        <Form method="post" replace>
          <input type="hidden" name="redirectTo" value={from} />
            <Segment stacked>
              <Input fluid icon='user' iconPosition='left' placeholder='Username' control='input' name='username' />
              <br />
              <Input
                fluid
                icon='lock'
                iconPosition='left'
                name='password'
                placeholder='Password'
                type='password'
              />
              <br />
              {attemptedLogin && (<Message
                error
                header='Failed login'
                content='Check your password and username and try again.'
                                  />)}
              <Button type="submit" color='teal' fluid size='large' onClick={() => {
                  setAttemptedLogin(true);
                }}> {/* disabled={isLoggingIn}> */}
                Login
              </Button>
            </Segment>
          {actionData && actionData.error ? (
            <p style={{ color: "red" }}>{actionData.error}</p>
          ) : null}
        </Form>
        <Message>
          New to us? <a href={PATHS.SIGNUP}>Sign Up</a>
        </Message>
      </Grid.Column>
    </Grid>
    </>
  );
}

async function loginAction({ request }: LoaderFunctionArgs) {
  let formData = await request.formData();
  let username = formData.get("username") as string | null;
  let password = formData.get("password") as string | null;

  // Validate our form inputs and return validation errors via useActionData()
  if (!username) {
    return {
      error: "You must provide a username to log in",
    };
  }

  // Sign in and redirect to the proper destination if successful.
  try {
    const loginRequest = await client.mutate({ mutation: LOGIN_MUATION, variables: { userName: username, password } });
    if (loginRequest.errors) {
      throw new Error();
    }
    if (loginRequest?.data?.login?.token) {
      await authProvider.signin(loginRequest?.data?.login?.token, loginRequest?.data?.login?.refreshToken);
    }
  } catch (error: any) {
    // Unused as of now but this is how you would handle invalid
    // username/password combinations - just like validating the inputs
    // above
    return {
      error: error.toString(),
    };
  }

  let redirectTo = formData.get("redirectTo") as string | null;
  return redirect(redirectTo || PATHS.ROOT);
}

async function loginLoader() {
  if (authProvider.isAuthenticated()) {
    return redirect(PATHS.COURSES);
  }
  return null;
}

function LogoutPage() {
  return (<div>
    Bye, <Link to={PATHS.LOGIN}>Login</Link> again soon.
  </div>);
}

export { LoginPage, LogoutPage, loginLoader, loginAction };
